export default __webpack_public_path__ + "static/media/logoWhite.12fb668d.png";